export { EdgeVM as EdgeRuntime } from '@edge-runtime/vm'
